export default __webpack_public_path__ + "static/media/onion.476600c4.png";